import script from "./EditAdvisorComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAdvisorComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditAdvisorComponent.vue?vue&type=style&index=0&id=4810f878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4810f878"]])

export default __exports__